import React, { useState } from "react";
import {
    Form,
    Input,
    Button,
    Typography,
    message,
    Spin
} from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { routes } from "../../routes/Routes";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import _NewapplicationService from "../../modules/NewapplicationService";
import { redirectToFirmAdminDashboard } from "../../utils/firmAdminRedirect";

import HeaderComponentWithTitleAndLogo from "../../components/HeaderComponentWithTitleAndLogo/HeaderComponentWithTitleAndLogo";
import MainLayout from "../../components/MainLayout/MainLayout";
import CreatePassword from "../../components/Password/CreatePassword";

const { Title, Text } = Typography;

const CreateNewPasswordForUser = () => {
    const history = useHistory();
    const location = useLocation();
    let data = location.state;
    let emailId = "";
    if (data && data.email) {
        emailId = data.email;
    }
    const redirectToFirmAdmin = data?.redirectToFirmAdmin === true;

    const [email] = useState(emailId);
    const [loading, setLoading] = useState(false);
    const appObjId = localStorage.getItem("ApplicationObjId");

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const reqObj = {
                Id: appObjId,
                ScreenName: "confirmpassword",
                Password: values.newPassword,
                ConfirmPassword: values.confirmPassword,
            }
            const res = await _NewapplicationService.updateUserPassword(reqObj);
            if (res.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message)
                if (redirectToFirmAdmin) {
                    await redirectToFirmAdminDashboard(email, values.newPassword, history);
                } else {
                    localStorage.setItem("IsKey",values.newPassword);
                    localStorage.setItem("isFromMyApplicationsList", false);
                    history.push(routes.ApplicantsDetails.path);
                }
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const validatePassword = (_, value) => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@%&!^*.,_+=?]).{8,20}$/;
        if (!value || passwordRegex.test(value)) {
            return Promise.resolve();
        }
        return Promise.reject(
            new Error(
                "Password must include uppercase, lowercase, number, special character and be 8-20 characters long"
            )
        );
    };

    const onBack = () => {
        history.push({ pathname: routes.VerifyOtp.path, state: email });
    }

    return (
        <Spin spinning={loading}>

            <MainLayout>
                <HeaderComponentWithTitleAndLogo
                    logoSrc="/websiteLogo.png"
                    logoAlt="Leveridge Logo"
                    title="Create New Password"
                    subtitle="Set a secure password for your account"
                />
                <CreatePassword
                    onFinish={onFinish}
                    validatePassword={validatePassword}
                    loading={loading}
                    onBack={onBack}
                />
            </MainLayout>
            {/* <LeftLayout>
                <div className="subBackgroundLayout mt40">
                    <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3", marginBottom: 60 }}>
                       Client Portal
                    </Title>

                    <Title level={4} style={{ marginBottom: 24 }}>
                        Create New Password
                    </Title>

                    <Form layout="vertical" onFinish={onFinish} requiredMark={true}>
                        <Form.Item
                            label="New Password"
                            name="newPassword"
                            rules={[
                                { required: true, message: "New Password is required" },
                                { validator: validatePassword }
                            ]}

                        >
                            <Input.Password maxLength={20} placeholder="Enter New Password" />
                        </Form.Item>

                        <Form.Item
                            label="Confirm Password"
                            name="confirmPassword"
                            dependencies={["newPassword"]}

                            rules={[
                                { required: true, message: "Confirm Password is required" },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue("newPassword") === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error("Passwords do not match"));
                                    }
                                })
                            ]}
                        >
                            <Input.Password maxLength={20} placeholder="Enter Confirm Password" />
                        </Form.Item>

                        <Text type="secondary" style={{ fontSize: 13 }}>
                            A password must contain at least 1 capital letter, 1 small letter, 1 number, 1 special character (#,@,%,!,&amp;,\*,\_,+,?, etc). Minimum 8 characters and maximum 20 characters.
                        </Text>
                        <Form.Item>
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: 16, marginTop: 30 }} >
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className="w100"
                                >
                                    Save And Proceed <RightOutlined />
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
                </div>
            </LeftLayout> */}
        </Spin>
    );
};

export default CreateNewPasswordForUser;